import { Action, createAction } from 'redux-actions';
import { PriceBreakdownState } from './reducers';

export const SET_PRICE = 'SET_PRICE';

export enum PriceBreakdownType {
	Total = 'Order',
	Service = 'Service',
	Upsale = 'Upsale'
}

export type SetPriceAction = Action<Partial<PriceBreakdownState>>;

export const setBreakdownPrices = createAction(SET_PRICE, (priceBreakdown: PriceBreakdownState) => priceBreakdown);
